import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardUsersStore } from '@lib/store';
import { cn } from '@shared/utils';
import type { UserResponse } from '@shared/api';
import { RemoveUserItem } from '../removeUserItem';
import { Button, Modal } from '@shared/widgets';

interface RemoveUsersModalProps {
  show: boolean;
  onClose: () => void;
  cardId: number;
  usersList: UserResponse[];
}

export const RemoveUsersModal = (props: RemoveUsersModalProps) => {
  const cardUsersStore = useUnit($cardUsersStore.store);

  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

  const { t } = useTranslation('card');

  const closeHandler = () => {
    setSelectedUsers([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedUsers.length) {
      closeHandler();
      return;
    }
    await Promise.allSettled(selectedUsers.map((userId) => $cardUsersStore.events.deleteUserInCard({ userIds: userId, cardIds: [props.cardId] })));
    setSelectedUsers([]);
    props.onClose();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('users.modals.removeUsers.title')}>
      <div className='flex flex-col gap-2'>
        {props.usersList.map((user) => (
          <RemoveUserItem
            key={user.id}
            className={cn(selectedUsers.includes(user.id) && 'pointer-events-none opacity-50')}
            firstName={`${user.firstName || ''} ${user.lastName || ''}`}
            onRemove={() => setSelectedUsers((prev) => [...prev, user.id])}
          />
        ))}
      </div>
      <div className='mt-6'>
        <Button color='primary' fullWidth disabled={cardUsersStore.actionLoading} onClick={confirmRemoveHandler}>
          {t('buttons.confirm', { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  );
};
